module.exports = __webpack_public_path__ + "static/img/streamer.f1fab33.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/streamer.webp
// module id = o/Dv
// module chunks = 0